import React, { forwardRef, useCallback } from 'react';
import { SpeechInputButton } from './SpeechInputButton';
import type { VoiceEnabledTextareaProps } from '../types/speech';

export const VoiceEnabledTextarea = forwardRef<
  HTMLTextAreaElement,
  VoiceEnabledTextareaProps
>(({ value, onChange, speechDisabled = false, className = '', ...props }, ref) => {
  const handleTranscript = useCallback(
    (text: string) => {
      // Append transcript to existing value with a space if needed
      const newValue = value ? `${value} ${text}`.trim() : text;

      // Create a synthetic event to maintain compatibility with form handlers
      const syntheticEvent = {
        target: { value: newValue },
        currentTarget: { value: newValue },
      } as React.ChangeEvent<HTMLTextAreaElement>;

      onChange(syntheticEvent);
    },
    [value, onChange]
  );

  return (
    <div className="relative">
      <textarea
        ref={ref}
        value={value}
        onChange={onChange}
        className={`pr-12 ${className}`}
        {...props}
      />
      <div className="absolute right-3 bottom-3">
        <SpeechInputButton
          onTranscript={handleTranscript}
          disabled={speechDisabled || props.disabled}
          appendMode={true}
        />
      </div>
    </div>
  );
});

VoiceEnabledTextarea.displayName = 'VoiceEnabledTextarea';

export default VoiceEnabledTextarea;
